const summary = (function() {
    function update() {
        const currentState = state.getState();
        const pricing = price.calculate();
        
        renderSelection(currentState);
        renderPricing(pricing);
    }

    function renderSelection(state) {
        const container = document.querySelector('.summary-selection');
        if (!container) return;

        const items = [
            { label: 'Belt Width', value: state.width },
            { label: 'Strap Type', value: state.strapMaterial },
            { label: 'Strap', value: state.strapName },
            { label: 'Buckle Type', value: state.buckleType },
            { label: 'Buckle', value: state.buckleName },
            { label: 'Belt End', value: state.end },
            { label: 'Stitching', value: state.stitch },
            { label: 'Embossing', value: state.emboss }
        ];

        let html = '<h3>YOUR SELECTION</h3>';
        items.forEach(item => {
            if (item.value) {
                html += `
                    <div class="summary-item">
                        <span class="summary-label">${item.label}</span>
                        <span class="summary-value">${item.value}</span>
                    </div>
                `;
            }
        });

        container.innerHTML = html;
    }

    function renderPricing(pricing) {
        const container = document.querySelector('.summary-pricing');
        if (!container) return;

        let html = '<h3>PRICING</h3>';
        
        if (pricing.strapPrice > 0) {
            html += `
                <div class="pricing-row">
                    <span>Strap</span>
                    <span>${price.format(pricing.strapPrice)}</span>
                </div>
            `;
        }
        
        if (pricing.bucklePrice > 0) {
            html += `
                <div class="pricing-row">
                    <span>Buckle</span>
                    <span>${price.format(pricing.bucklePrice)}</span>
                </div>
            `;
        }
        
        if (pricing.endPrice > 0) {
            html += `
                <div class="pricing-row">
                    <span>Belt End</span>
                    <span>${price.format(pricing.endPrice)}</span>
                </div>
            `;
        }
        
        if (pricing.stitchPrice > 0) {
            html += `
                <div class="pricing-row">
                    <span>Stitching</span>
                    <span>${price.format(pricing.stitchPrice)}</span>
                </div>
            `;
        }
        
        if (pricing.embossPrice > 0) {
            html += `
                <div class="pricing-row">
                    <span>Embossing</span>
                    <span>${price.format(pricing.embossPrice)}</span>
                </div>
            `;
        }
        
        html += `
            <div class="pricing-row">
                <span>Craft Fee</span>
                <span>${price.format(pricing.craftFee)}</span>
            </div>
            <div class="pricing-divider"></div>
            <div class="pricing-row total">
                <span>Total</span>
                <span>${price.format(pricing.total)}</span>
            </div>
        `;

        container.innerHTML = html;
    }

    function init() {
        state.subscribe(update);
        update();
    }

    return {
        init,
        update
    };
})();

document.addEventListener('DOMContentLoaded', summary.init);